export en_US from './dics/en_US';
export ru_RU from './dics/ru_RU';
export jp_JP from './dics/jp_JP';
export ar_AR from './dics/ar_AR';
export es_MX from './dics/es_MX';
export az_AZ from './dics/az_AZ';
export pt_BR from './dics/pt_BR';

//Personal translation
export en_RC from './dics/ext/rc/en_RC';
export en_AS from './dics/ext/appstar/en_AS';
export en_BT from './dics/ext/bluechip-tv/en_BT';
export en_DW from './dics/ext/digital-west/en_DW';
export en_DC from './dics/ext/direct-com/en_DC';
export en_KO from './dics/ext/knockout/en_KO';
export en_JB from './dics/ext/jabba/en_JB';
export en_VERIGO from './dics/ext/verigo/en_VERIGO';
export en_POVTV from './dics/ext/povtv/en_POVTV';
export ru_POVTV from './dics/ext/povtv/ru_POVTV';
export en_WLFORUM from './dics/ext/wlforum/en_WLFORUM';
export az_NAR from './dics/ext/nar/az_NAR';
export en_NAR from './dics/ext/nar/en_NAR';
export ru_NAR from './dics/ext/nar/ru_NAR';
export en_AR from './dics/ext/art/en_AR';
export ar_RT from './dics/ext/art/ar_RT';



// WEBPACK FOOTER //
// ./src/locales/index.js